// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".registration h3[data-v-610bfedb]{font-size:26px;font-weight:500;line-height:39px;text-align:center;margin:auto;margin-bottom:80px}", ""]);
// Exports
module.exports = exports;
